// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"testimonials-module--subtitle--3q82D"};